/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Operator_TitleInputs */

const en_meta_showcase_operator_title = /** @type {(inputs: Meta_Showcase_Operator_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotel Operator Dashboard & Reservation Manager | Lindevo`)
};

const lv_meta_showcase_operator_title = /** @type {(inputs: Meta_Showcase_Operator_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viesnīcas operatora panelis un rezervācijas | Lindevo`)
};

/**
* | output |
* | --- |
* | "Hotel Operator Dashboard & Reservation Manager \| Lindevo" |
*
* @param {Meta_Showcase_Operator_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_operator_title = /** @type {((inputs?: Meta_Showcase_Operator_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Operator_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_operator_title(inputs)
	return en_meta_showcase_operator_title(inputs)
});